<template lang="html">
  <svg xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" height="22" width="18.333" version="1.1" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" viewBox="0 0 18.332999 22.000001">
   <g transform="translate(0 -1030.4)">
    <g style="fill:#497ea8" transform="matrix(.042969 0 0 .042969 -1.8333 1030.4)">
     <g style="fill:#497ea8" transform="matrix(1.25,0,0,-1.25,0,45)">
      <g style="fill:#497ea8">
       <g style="fill:#497ea8">
        <path style="fill:#497ea8" d="m318.58-111.91c0-125.16 56.889-113.78 56.889-170.67 0 0 0-22.756-22.756-22.756h-295.82c-22.756 0-22.756 22.756-22.756 22.756 0 56.889 56.889 45.511 56.889 170.67 0 62.828 50.938 113.78 113.78 113.78 62.84 0 113.78-50.95 113.78-113.78"/>
        <path style="fill:#497ea8" d="m238.93 1.867c0 18.853-15.29 34.133-34.13 34.133-18.85 0-34.13-15.28-34.13-34.133s15.28-34.133 34.133-34.133c18.842-.001 34.133 15.28 34.133 34.133"/>
        <path style="fill:#497ea8" d="m204.8-373.6c25.134 0 45.511 20.378 45.511 45.511h-91.022c0-25.133 20.377-45.511 45.511-45.511"/>
       </g>
      </g>
     </g>
    </g>
   </g>
  </svg>

</template>

<script>
export default {
  name: 'AlertMessage'
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/icons/AlertMessage.vue